// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Process Visualization Widget Scoped Styles */
/* All styles are scoped within .process-visualizer to prevent conflicts */

.process-visualizer {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    line-height: 1.6;
    color: #333;
    background-color: #f5f5f5;
    display: flex;
    flex-direction: column;
    min-height: 400px;
    position: relative;
    box-sizing: border-box;
}

.process-visualizer *,
.process-visualizer *::before,
.process-visualizer *::after {
    box-sizing: border-box;
}

/* Header Styles */
.process-visualizer .pv-header {
    background-color: #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    padding: 1rem 2rem;
}

.process-visualizer .pv-title {
    color: #2c3e50;
    margin: 0 0 1rem 0;
    font-size: 1.5rem;
    font-weight: 600;
}

.process-visualizer .pv-filter-container {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: end;
}

.process-visualizer .pv-filter-controls {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.process-visualizer .pv-filter-controls label {
    font-size: 0.9rem;
    white-space: nowrap;
}

.process-visualizer .pv-filter-controls input[type="range"] {
    width: 100px;
}

.process-visualizer .pv-filter-controls span {
    min-width: 40px;
    text-align: center;
    font-weight: bold;
    font-size: 0.9rem;
}

.process-visualizer .pv-zoom-controls {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-left: auto;
    justify-content: center;
}

.process-visualizer .pv-zoom-btn {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    background-color: #3498db;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.process-visualizer .pv-zoom-btn:hover {
    background-color: #2980b9;
}

.process-visualizer .pv-zoom-label {
    font-size: 0.9rem;
    color: #666;
}

/* Main Content Styles */
.process-visualizer .pv-main {
    display: flex;
    flex: 1 1;
    padding: 0.5rem;
    gap: 1rem;
    min-height: 550px; 
}

.process-visualizer .pv-graph-container {
    flex: 3 1;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    min-height: 400px;
    position: relative;
    min-width: 0; /* Allow flex child to shrink */
    overflow: hidden; /* Prevent content overflow */
}

.process-visualizer .pv-sidebar{
    flex: 1 1;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    padding: 1rem;
    min-width: 250px;
    max-width: 350px;
    flex-shrink: 0; /* Prevent metrics panel from shrinking too much */
}


.process-visualizer .pv-metrics-title {
    color: #2c3e50;
    margin: 0 0 1rem 0;
    font-size: 1.2rem;
    border-bottom: 1px solid #eee;
    padding-bottom: 0.5rem;
}

.process-visualizer .pv-metrics-content {
    font-size: 0.9rem;
}

/* Footer Styles */
.process-visualizer .pv-footer {
    padding: 1rem 2rem;
    background-color: #2c3e50;
    color: white;
    text-align: center;
    margin-top: auto;
}

.process-visualizer .pv-footer p {
    margin: 0;
    font-size: 0.9rem;
}

/* Loading Overlay */
.process-visualizer .pv-loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.9);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.process-visualizer .pv-loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    animation: pv-spin 1s linear infinite;
    margin-bottom: 1rem;
}

@keyframes pv-spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.process-visualizer .pv-loading-text {
    color: #666;
    font-size: 0.9rem;
}

/* Message Styles */
.process-visualizer .pv-message {
    position: absolute;
    top: 20px;
    right: 20px;
    padding: 10px 20px;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 9999;
    transition: opacity 0.3s ease;
    font-size: 0.9rem;
    max-width: 300px;
    word-wrap: break-word;
}

.process-visualizer .pv-message-success {
    background-color: #2ecc71;
    color: white;
}

.process-visualizer .pv-message-error {
    background-color: #e74c3c;
    color: white;
}

.process-visualizer .pv-message-info {
    background-color: #3498db;
    color: white;
}

/* Graph Styles (Cytoscape overrides) */
.process-visualizer .pv-graph-container canvas {
    border-radius: 8px;
}

/* Responsive Design */
@media (max-width: 768px) {
    .process-visualizer .pv-main {
        flex-direction: column;
    }
    
    .process-visualizer .pv-metrics-panel {
        max-width: 100%;
        min-width: auto;
    }
    
    .process-visualizer .pv-filter-container {
        flex-direction: column;
        gap: 0.5rem;
    }
    
    .process-visualizer .pv-filter-controls {
        margin-left: 0;
    }
    
    .process-visualizer .pv-zoom-controls {
        margin-left: 0;
        margin-top: 0.5rem;
    }
    
    .process-visualizer .pv-header {
        padding: 1rem;
    }
    
    .process-visualizer .pv-main {
        padding: 0.5rem;
    }
}

@media (max-width: 480px) {
    .process-visualizer .pv-title {
        font-size: 1.2rem;
    }
    
    .process-visualizer .pv-filter-controls {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.25rem;
    }
    
    .process-visualizer .pv-filter-controls input[type="range"] {
        width: 150px;
    }
    
    .process-visualizer .pv-message {
        position: fixed;
        top: 10px;
        left: 10px;
        right: 10px;
        max-width: none;
    }
}

/* Theme Support */
.process-visualizer.pv-theme-dark {
    background-color: #2c3e50;
    color: #ecf0f1;
}

.process-visualizer.pv-theme-dark .pv-header {
    background-color: #34495e;
    color: #ecf0f1;
}

.process-visualizer.pv-theme-dark .pv-title {
    color: #ecf0f1;
}

.process-visualizer.pv-theme-dark .pv-graph-container,
.process-visualizer.pv-theme-dark .pv-metrics-panel {
    background-color: #34495e;
    color: #ecf0f1;
}

.process-visualizer.pv-theme-dark .pv-metrics-title {
    color: #ecf0f1;
    border-bottom-color: #4a5f7a;
}

.process-visualizer.pv-theme-dark .pv-footer {
    background-color: #1a252f;
}

/* Compact Mode */
.process-visualizer.pv-compact .pv-header {
    padding: 0.5rem 1rem;
}

.process-visualizer.pv-compact .pv-title {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
}

.process-visualizer.pv-compact .pv-main {
    padding: 0.5rem;
}

.process-visualizer.pv-compact .pv-metrics-panel {
    padding: 0.5rem;
    min-width: 200px;
    max-width: 250px;
}

.process-visualizer.pv-compact .pv-footer {
    padding: 0.5rem 1rem;
}

/* Hide components when disabled */
.process-visualizer.pv-no-header .pv-header {
    display: none;
}

.process-visualizer.pv-no-footer .pv-footer {
    display: none;
}

.process-visualizer.pv-no-metrics .pv-metrics-panel {
    display: none;
}

.process-visualizer.pv-no-filters .pv-filter-container {
    display: none;
}

.process-visualizer.pv-no-zoom .pv-zoom-controls {
    display: none;
}

/* Full width when metrics panel is hidden */
.process-visualizer.pv-no-metrics .pv-graph-container {
    flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/process-graph-widget/css/widget-styles.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C,0EAA0E;;AAE1E;IACI,4DAA4D;IAC5D,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA,kBAAkB;AAClB;IACI,sBAAsB;IACtB,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,SAAO;IACP,eAAe;IACf,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,uBAAuB;IACvB,kBAAkB;IAClB,0CAA0C;IAC1C,iBAAiB;IACjB,kBAAkB;IAClB,YAAY,EAAE,+BAA+B;IAC7C,gBAAgB,EAAE,6BAA6B;AACnD;;AAEA;IACI,SAAO;IACP,uBAAuB;IACvB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,cAAc,EAAE,kDAAkD;AACtE;;;AAGA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,iBAAiB;AACrB;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA,uCAAuC;AACvC;IACI,kBAAkB;AACtB;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,SAAS;QACT,UAAU;QACV,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA,kBAAkB;AAClB;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,kCAAkC;AAClC;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA,4CAA4C;AAC5C;IACI,SAAO;AACX","sourcesContent":["/* Process Visualization Widget Scoped Styles */\n/* All styles are scoped within .process-visualizer to prevent conflicts */\n\n.process-visualizer {\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    line-height: 1.6;\n    color: #333;\n    background-color: #f5f5f5;\n    display: flex;\n    flex-direction: column;\n    min-height: 400px;\n    position: relative;\n    box-sizing: border-box;\n}\n\n.process-visualizer *,\n.process-visualizer *::before,\n.process-visualizer *::after {\n    box-sizing: border-box;\n}\n\n/* Header Styles */\n.process-visualizer .pv-header {\n    background-color: #fff;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    padding: 1rem 2rem;\n}\n\n.process-visualizer .pv-title {\n    color: #2c3e50;\n    margin: 0 0 1rem 0;\n    font-size: 1.5rem;\n    font-weight: 600;\n}\n\n.process-visualizer .pv-filter-container {\n    display: flex;\n    gap: 1rem;\n    flex-wrap: wrap;\n    justify-content: end;\n}\n\n.process-visualizer .pv-filter-controls {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.process-visualizer .pv-filter-controls label {\n    font-size: 0.9rem;\n    white-space: nowrap;\n}\n\n.process-visualizer .pv-filter-controls input[type=\"range\"] {\n    width: 100px;\n}\n\n.process-visualizer .pv-filter-controls span {\n    min-width: 40px;\n    text-align: center;\n    font-weight: bold;\n    font-size: 0.9rem;\n}\n\n.process-visualizer .pv-zoom-controls {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-left: auto;\n    justify-content: center;\n}\n\n.process-visualizer .pv-zoom-btn {\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.2rem;\n    background-color: #3498db;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.process-visualizer .pv-zoom-btn:hover {\n    background-color: #2980b9;\n}\n\n.process-visualizer .pv-zoom-label {\n    font-size: 0.9rem;\n    color: #666;\n}\n\n/* Main Content Styles */\n.process-visualizer .pv-main {\n    display: flex;\n    flex: 1;\n    padding: 0.5rem;\n    gap: 1rem;\n    min-height: 550px; \n}\n\n.process-visualizer .pv-graph-container {\n    flex: 3;\n    background-color: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n    min-height: 400px;\n    position: relative;\n    min-width: 0; /* Allow flex child to shrink */\n    overflow: hidden; /* Prevent content overflow */\n}\n\n.process-visualizer .pv-sidebar{\n    flex: 1;\n    background-color: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n    padding: 1rem;\n    min-width: 250px;\n    max-width: 350px;\n    flex-shrink: 0; /* Prevent metrics panel from shrinking too much */\n}\n\n\n.process-visualizer .pv-metrics-title {\n    color: #2c3e50;\n    margin: 0 0 1rem 0;\n    font-size: 1.2rem;\n    border-bottom: 1px solid #eee;\n    padding-bottom: 0.5rem;\n}\n\n.process-visualizer .pv-metrics-content {\n    font-size: 0.9rem;\n}\n\n/* Footer Styles */\n.process-visualizer .pv-footer {\n    padding: 1rem 2rem;\n    background-color: #2c3e50;\n    color: white;\n    text-align: center;\n    margin-top: auto;\n}\n\n.process-visualizer .pv-footer p {\n    margin: 0;\n    font-size: 0.9rem;\n}\n\n/* Loading Overlay */\n.process-visualizer .pv-loading-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(255, 255, 255, 0.9);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.process-visualizer .pv-loading-spinner {\n    width: 40px;\n    height: 40px;\n    border: 4px solid #f3f3f3;\n    border-top: 4px solid #3498db;\n    border-radius: 50%;\n    animation: pv-spin 1s linear infinite;\n    margin-bottom: 1rem;\n}\n\n@keyframes pv-spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.process-visualizer .pv-loading-text {\n    color: #666;\n    font-size: 0.9rem;\n}\n\n/* Message Styles */\n.process-visualizer .pv-message {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    padding: 10px 20px;\n    border-radius: 4px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    z-index: 9999;\n    transition: opacity 0.3s ease;\n    font-size: 0.9rem;\n    max-width: 300px;\n    word-wrap: break-word;\n}\n\n.process-visualizer .pv-message-success {\n    background-color: #2ecc71;\n    color: white;\n}\n\n.process-visualizer .pv-message-error {\n    background-color: #e74c3c;\n    color: white;\n}\n\n.process-visualizer .pv-message-info {\n    background-color: #3498db;\n    color: white;\n}\n\n/* Graph Styles (Cytoscape overrides) */\n.process-visualizer .pv-graph-container canvas {\n    border-radius: 8px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .process-visualizer .pv-main {\n        flex-direction: column;\n    }\n    \n    .process-visualizer .pv-metrics-panel {\n        max-width: 100%;\n        min-width: auto;\n    }\n    \n    .process-visualizer .pv-filter-container {\n        flex-direction: column;\n        gap: 0.5rem;\n    }\n    \n    .process-visualizer .pv-filter-controls {\n        margin-left: 0;\n    }\n    \n    .process-visualizer .pv-zoom-controls {\n        margin-left: 0;\n        margin-top: 0.5rem;\n    }\n    \n    .process-visualizer .pv-header {\n        padding: 1rem;\n    }\n    \n    .process-visualizer .pv-main {\n        padding: 0.5rem;\n    }\n}\n\n@media (max-width: 480px) {\n    .process-visualizer .pv-title {\n        font-size: 1.2rem;\n    }\n    \n    .process-visualizer .pv-filter-controls {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 0.25rem;\n    }\n    \n    .process-visualizer .pv-filter-controls input[type=\"range\"] {\n        width: 150px;\n    }\n    \n    .process-visualizer .pv-message {\n        position: fixed;\n        top: 10px;\n        left: 10px;\n        right: 10px;\n        max-width: none;\n    }\n}\n\n/* Theme Support */\n.process-visualizer.pv-theme-dark {\n    background-color: #2c3e50;\n    color: #ecf0f1;\n}\n\n.process-visualizer.pv-theme-dark .pv-header {\n    background-color: #34495e;\n    color: #ecf0f1;\n}\n\n.process-visualizer.pv-theme-dark .pv-title {\n    color: #ecf0f1;\n}\n\n.process-visualizer.pv-theme-dark .pv-graph-container,\n.process-visualizer.pv-theme-dark .pv-metrics-panel {\n    background-color: #34495e;\n    color: #ecf0f1;\n}\n\n.process-visualizer.pv-theme-dark .pv-metrics-title {\n    color: #ecf0f1;\n    border-bottom-color: #4a5f7a;\n}\n\n.process-visualizer.pv-theme-dark .pv-footer {\n    background-color: #1a252f;\n}\n\n/* Compact Mode */\n.process-visualizer.pv-compact .pv-header {\n    padding: 0.5rem 1rem;\n}\n\n.process-visualizer.pv-compact .pv-title {\n    font-size: 1.2rem;\n    margin-bottom: 0.5rem;\n}\n\n.process-visualizer.pv-compact .pv-main {\n    padding: 0.5rem;\n}\n\n.process-visualizer.pv-compact .pv-metrics-panel {\n    padding: 0.5rem;\n    min-width: 200px;\n    max-width: 250px;\n}\n\n.process-visualizer.pv-compact .pv-footer {\n    padding: 0.5rem 1rem;\n}\n\n/* Hide components when disabled */\n.process-visualizer.pv-no-header .pv-header {\n    display: none;\n}\n\n.process-visualizer.pv-no-footer .pv-footer {\n    display: none;\n}\n\n.process-visualizer.pv-no-metrics .pv-metrics-panel {\n    display: none;\n}\n\n.process-visualizer.pv-no-filters .pv-filter-container {\n    display: none;\n}\n\n.process-visualizer.pv-no-zoom .pv-zoom-controls {\n    display: none;\n}\n\n/* Full width when metrics panel is hidden */\n.process-visualizer.pv-no-metrics .pv-graph-container {\n    flex: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
